module.exports = __webpack_public_path__ + "img/制御工学6_6_5.03ce1f0a.png";